export const LANGUAGE_NATIVE_NAMES = {
  en: "English",
  sr: "Srpski",
  hr: "Hrvatski",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  ru: "Русский",
  zh: "中文",
  ja: "日本語",
  ko: "한국어",
  pl: "Polski",
  cs: "Čeština",
  hu: "Magyar",
  ro: "Română",
  bg: "Български",
  el: "Ελληνικά",
  nl: "Nederlands",
  sv: "Svenska",
  no: "Norsk",
  da: "Dansk",
  fi: "Suomi",
  tr: "Türkçe",
  ar: "العربية",
  he: "עברית",
  uk: "Українська",
  sk: "Slovenčina",
  sl: "Slovenščina",
  mk: "Македонски",
  bs: "Bosanski",
  sq: "Shqip",
  hi: "हिन्दी",
};
